"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _WithdrawTemplateFormComponent = _interopRequireDefault(require("./WithdrawTemplateFormComponent"));
var _depositWithdrawalSelectors = require("../../../redux/selectors/depositWithdrawalSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state, _ref) {
  var submitting = _ref.submitting,
    invalid = _ref.invalid,
    onAmountChange = _ref.onAmountChange,
    baseClasses = _ref.baseClasses,
    errorMessage = _ref.errorMessage;
  return {
    template: state.withdraw.template,
    withdrawWorkflowInfo: state.withdraw.withdrawWorkflowInfo,
    product: (0, _depositWithdrawalSelectors.withdrawProductSelector)(state),
    onAmountChange: onAmountChange,
    submitting: submitting,
    invalid: invalid,
    baseClasses: baseClasses,
    errorMessage: errorMessage
  };
};
var mapDispatchToProps = {
  change: _reduxForm.change
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_WithdrawTemplateFormComponent["default"]);